import { CountryISO } from 'app/core/enums';
import { ICountryDniRelation } from 'app/core/interfaces';
import { IdentificationTypes } from 'app/core/enums';

export const CountryDniRelation: ICountryDniRelation[] = [
  {
    name: 'CHILE',
    isoCode: CountryISO.Chile,
    option: IdentificationTypes.CB_IDENTIFICACION_RUT,
  },
  {
    name: 'PERÚ',
    isoCode: CountryISO.Peru,
    option: IdentificationTypes.CB_IDENTIFICACION_RUC,
  },
  {
    name: 'PERÚ',
    isoCode: CountryISO.Peru,
    option: IdentificationTypes.CB_IDENTIFICACION_DNI,
  },
  {
    name: 'BRASIL',
    isoCode: CountryISO.Brazil,
    option: IdentificationTypes.CB_IDENTIFICACION_CPF,
  },
  {
    name: 'BRASIL',
    isoCode: CountryISO.Brazil,
    option: IdentificationTypes.CB_IDENTIFICACION_CNPJ,
  },
  {
    name: 'MEXICO',
    isoCode: CountryISO.Mexico,
    option: IdentificationTypes.CB_IDENTIFICACION_RFCPM,
  },
  {
    name: 'MEXICO',
    isoCode: CountryISO.Mexico,
    option: IdentificationTypes.CB_IDENTIFICACION_RFCPF,
  },
  {
    name: 'OTRO',
    isoCode: CountryISO.Otro,
    option: IdentificationTypes.CB_IDENTIFICACION_OTHER,
  },
];

export const CountryWithDefinedDNI: CountryISO[] = [
  CountryISO.Chile,
  CountryISO.Peru,
  CountryISO.Brazil,
  CountryISO.Mexico,
];
